import { Box } from '@vouched.id/vault';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Dropdown } from '../Dropdown';
import { useGlobalState } from 'store/reducers/reducer';
import { downloadJob } from 'store/sagas/sagas';
import { base64ToArrayBuffer, saveByteArray } from 'utils/ui.utils';
export const FilesDropdown = ({ fileNamePrefix = 'IDV', jobStatus, showConfidencesToggle = true }) => {
    const { asyncDispatch } = useGlobalState();
    const { id: jobSid } = useParams();
    const handleDownload = useCallback((sid, confValue) => {
        asyncDispatch(downloadJob(sid, confValue))
            .then((res) => {
            const fileName = `${fileNamePrefix}_${sid}_Internal_Use.pdf`;
            const sampleBytes = base64ToArrayBuffer(res.pdf);
            saveByteArray([sampleBytes], fileName);
        })
            .catch(console.error);
    }, [asyncDispatch, fileNamePrefix]);
    return (React.createElement(Dropdown, { title: "Files" }, jobStatus !== 'active' && (React.createElement(React.Fragment, null,
        React.createElement(Box, { marginBottom: "spacing.default" },
            React.createElement("a", { onClick: () => {
                    handleDownload(jobSid, true);
                } },
                React.createElement("i", { "aria-hidden": "true", className: "pointer fas fa-download" }),
                "Report")),
        showConfidencesToggle && (React.createElement(Box, { marginBottom: "spacing.default" },
            React.createElement("a", { onClick: () => {
                    handleDownload(jobSid, false);
                } },
                React.createElement("i", { "aria-hidden": "true", className: "pointer fas fa-download" }),
                "NoConfReport")))))));
};
